import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { UpdateCustomerProps } from 'app/services/admin.service';

export interface EditSubAgencyModalInput {
	shortName: string;
}

@Component({
  selector: 'app-edit-sub-agency-modal',
  templateUrl: './edit-sub-agency-modal.component.html',
  styleUrls: ['./edit-sub-agency-modal.component.css']
})
export class EditSubAgencyModalComponent implements OnInit {

	public shortName: string;
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: EditSubAgencyModalInput,
		public dialogRef: MatDialogRef<EditSubAgencyModalComponent>
	) { }

	cancel() {
		this.dialogRef.close();
	}
	save() {
		const data: UpdateCustomerProps = {
			customerShortName: this.shortName
		}
		this.dialogRef.close(data);
	}
	ngOnInit() {
		this.shortName = this.data.shortName;
	}

}
